import { render, staticRenderFns } from "./ClaimManage.vue?vue&type=template&id=de67d070&"
import script from "./ClaimManage.vue?vue&type=script&lang=js&"
export * from "./ClaimManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports